<!-- eslint-disable vue/valid-v-for -->
<template>
  <div class="residence-container">
    <div class="banner-container">
      <img
        src="../../../assets/images/residence/banner1.jpg"
      />
    </div>
    <p class="section-title-line">
      <span>D10天系</span>
    </p>
    <div class="section-container intro-box-content">
      <p>凝结艺术大师的灵魂和历练，</p>
      <p>换来隽永之不凡。</p>
      <p>黄昏落日，山川地貌，</p>
      <p>气度自不凡。</p>
      <p>天系，带来优雅绝尘的都市场景。</p>
      <p>为尊崇而来，</p>
      <p>境界天下，礼乐尽展。</p>
    </div>

    <div class="section-container">
      <div v-for="(item, index) in list" :key="item.name + index">
        <project-show :data="item"></project-show>
      </div>
    </div>
  </div>
</template>
<script>
import ProjectShow from "@/components/projectShow";

export default {
  name: "TianXiPage",
  components: {
    ProjectShow,
  },
  data() {
    return {
      list: [
        {
          name: "新希望·D10天府",
          title: "市中心·太古里旁·中国建筑新地标",
          desc: [
            "择址东大街地脉，",
            "秉承“天”系先锋艺术打造理念，",
            "凝练醇熟商业、交通、医疗、教育配套，",
            "新希望地产深耕成都20年大成之作，",
            "树立成都品质人居新标杆。",
            "<br />",
            "<br />",
            "<br />",
            "<br />",
            "*「中国建筑新地标」（中指研究院 2018年〕",
            "*「全国十大交付力作品」（易居·克而瑞2022年）",
          ],
          footer: ["Tel：+86（28）8777 9997", "Add：成都·锦江区·锦东路"],
          images: [
            require("../../../assets/images/residence/1-1.jpg"),
            require("../../../assets/images/residence/1-2.jpg"),
            require("../../../assets/images/residence/1-3.jpg"),
            require("../../../assets/images/residence/1-4.jpg"),
            require("../../../assets/images/residence/1-5.jpg"),
            require("../../../assets/images/residence/1-6.jpg"),
          ],
        },
      ],
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
};
</script>
<style lang="scss" scoped>
.residence-container {
}
</style>
